module.exports = __webpack_public_path__ + "static/media/questions.32d9b2d6.svg";